// import library
import { useTranslation } from "react-i18next";
// import component
import Layout from "../../layouts/Layout";

const Setting = () => {
    // variables
    const { t } = useTranslation();
    
    return (
        <Layout>
            <div className="space-y-4">
                <div className="flex justify-between items-center">
                    <div>
                        <h1 className="lg:text-2xl font-semibold capitalize">{ t('settings') }</h1>
                        <p className="text-light-400 text-sm capitalize">{ t('profile') } / { t('settings') }</p>
                    </div>
                </div>
                <div className="p-4 bg-white border border-white rounded-lg flex flex-col justify-center">
                    <div className="text-center">
                        coming soon
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Setting;